<template>
  <v-card :class="{ 'ma-6': !xs }">
    <v-card-title class="titles">
      {{ $t('thirdPartyTable.titleTSI') }}
    </v-card-title>
    <v-container fluid> </v-container>
  </v-card>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { useDisplay } from 'vuetify'

export default defineComponent({
  name: 'TsiTable',
  setup() {
    const { xs } = useDisplay()
    return { xs }
  }
})
</script>

<style lang="scss" scoped>
.titles {
  font-weight: 300;
  padding: 16px;
}
</style>
